import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'
import { useMutation } from 'urql'
import Button from './Button'
import Input from './Input'
import Modal from './Modal'
import { Responses } from '../util/consts'
import { UpdateClient } from '../graphql/mutations'
import BoxNotification from './BoxNotification'

const initialState = {
    name: '',
    email: '',
    phone: '',
    address: '',
}

const initialErrorsState = {
    name: null,
    email: null,
    role: null,
    generic: null,
}

const EditClientModal = ({
    show,
    close,
    onSuccess,
    client,
}) => {

    const { t } = useTranslation()
    const [item, setItem] = useState(initialState)
    const [errors, setErrors] = useState(initialErrorsState)
    const [, updateClient] = useMutation(UpdateClient)
    const [loading, setLoading] = useState(false)

    useEffect(() => {
        if (client) {
            setItem(client)
            return
        }
        setItem(initialState)
    }, [client])

    const hasInputErrors = () => {
        let hasErrors = false
        const errorState = {
            ...initialErrorsState,
        }

        if (item.name.length < 3) {
            hasErrors = true
            errorState.name = t('clients.fill_field')
        }

        setErrors({
            ...errorState,
        })
        return hasErrors
    }

    const handleUpdate = async () => {
        if (hasInputErrors()) return
        setLoading(true)
        try {
            const { data } = await updateClient({
                id: item.id,
                data: {
                    name: item.name,
                    email: item.email,
                    phone: item.phone,
                    address: item.address,
                },
            })

            if (!data?.updateClient || data.updateClient !== Responses.Success) {
                setErrors({
                    ...initialErrorsState,
                    generic: data.updateClient === Responses.Exists ? t('clients.user_exists') : t('clients.add_error'),
                })
                return
            }

            if (onSuccess) onSuccess(data.updateClient)
        } catch (err) {
            setErrors({
                ...initialErrorsState,
                generic: t('clients.add_error'),
            })
            console.log(err)
        } finally {
            setLoading(false)
        }
    }

    const handleClose = () => {
        if (close) close()
        setErrors(initialErrorsState)
        setItem(initialState)
    }

    const setField = (field, value) => {
        setErrors({
            ...errors,
            [field]: null,
        })
        setItem({
            ...item,
            [field]: value,
        })
    }

    return (
        <Modal
            className={'modal-client'}
            show={show}
            close={handleClose}
            title={ t('clients.edit_title') }
        >
            <Input
                label={ t('users.name') }
                placeholder={ t('users.name') }
                value={item.name}
                onChange={(e) => setField('name', e.target.value)}
                error={errors.name}
            />
            <Input
                label={ t('clients.email') }
                value={item.email}
                onChange={(e) => setField('email', e.target.value)}
                error={errors.email}
            />
            <Input
                label={ t('clients.phone') }
                value={item.phone}
                onChange={(e) => setField('phone', e.target.value)}
                error={errors.phone}
            />
            <Input
                label={ t('clients.address') }
                value={item.address}
                onChange={(e) => setField('address', e.target.value)}
                error={errors.address}
            />

            {
                errors?.generic ?
                <BoxNotification
                    message={errors.generic}
                    type={'error'}
                />
                :
                <></>
            }

            <Button
                label={ t('clients.save') }
                onClick={handleUpdate}
                loading={loading}
            />
        </Modal>
    )
}

EditClientModal.propTypes = {
    show: PropTypes.bool,
    close: PropTypes.func,
    onSuccess: PropTypes.func,
    client: PropTypes.object,
}

export default EditClientModal